var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "whatsapp-channel-detail" } },
    [
      _vm.channel
        ? _c("div", { staticClass: "wrapper" }, [
            _c("div", { staticClass: "toolbar" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c(
                    "IconButton",
                    {
                      attrs: {
                        "on-click": function () {
                          return _vm.$router.push("/integrations/whatsapp-v1")
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v(" chevron_left "),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "icon-container" },
                    [_c("WhatsappIcon")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(
                      _vm._s(_vm.$t("whatsapp.whatsappV1Channel")) +
                        " : " +
                        _vm._s(_vm.channel.name)
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.channel,
                      expression: "channel",
                    },
                  ],
                  staticClass: "right",
                },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          _vm.visible = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("wp.startChatWithAnyNo")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", disabled: !_vm.restartEnabled },
                      on: { click: _vm.restartChannel },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("whatsappChannel.restartChannel")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("whatsappChannel.deleteChannel")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "channel-content" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c("SidebarChild", {
                    attrs: {
                      items: _vm.menuItems,
                      "selected-item": _vm.type,
                      focusActive: true,
                    },
                    on: {
                      selected: function (i) {
                        return (_vm.type = i.key)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.channel
                ? _c("div", { staticClass: "page-content" }, [
                    _vm.type === "integration"
                      ? _c(
                          "div",
                          [
                            _c("WhatsappWizard", {
                              attrs: { channel: _vm.channel },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "detail"
                      ? _c(
                          "div",
                          [
                            _c("UpdateDetail", {
                              attrs: { "show-visibility-config": false },
                              model: {
                                value: _vm.channel,
                                callback: function ($$v) {
                                  _vm.channel = $$v
                                },
                                expression: "channel",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "visibility"
                      ? _c(
                          "div",
                          [
                            _c("Visibility", {
                              model: {
                                value: _vm.channel,
                                callback: function ($$v) {
                                  _vm.channel = $$v
                                },
                                expression: "channel",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "all-contacts"
                      ? _c(
                          "div",
                          [
                            _c("WhatsappContactList", {
                              attrs: {
                                channel: _vm.channel,
                                "channel-id": _vm.channel._id,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "broadcast-requests"
                      ? _c(
                          "div",
                          [
                            _c("BroadcastRequests", {
                              attrs: {
                                channel: _vm.channel,
                                changePage: _vm.changePage,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "customer-groups"
                      ? _c(
                          "div",
                          [
                            _c("CustomerGroups", {
                              attrs: {
                                channel: _vm.channel,
                                changePage: _vm.changePage,
                                "channel-id": _vm.channel._id,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type === "wallet"
                      ? _c(
                          "div",
                          { staticStyle: { padding: "10px" } },
                          [_c("Wallet")],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            icon: "exclamation-circle",
            title: _vm.$t("whatsappChannel.whatsappChannel"),
          },
          on: {
            cancel: function ($event) {
              _vm.deleteModal = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.dismiss")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "danger" },
                      on: { click: _vm.deleteWhatsappChannel },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.delete")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.deleteModal,
            callback: function ($$v) {
              _vm.deleteModal = $$v
            },
            expression: "deleteModal",
          },
        },
        [
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("whatsappChannel.deleteWhatsappChannelDescription"))
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "row d-flex flex-row",
          attrs: {
            title: _vm.$t("wp.typeInANumberDesc"),
            visible: _vm.visible,
            "confirm-loading": _vm.confirmLoading,
          },
          on: {
            ok: function ($event) {
              return _vm.startChat(_vm.whatsappNumber)
            },
            cancel: _vm.handleCancel,
          },
        },
        [
          _vm.showAlertMessage
            ? _c(
                "div",
                { staticClass: "pb-3" },
                [
                  _c("a-alert", {
                    attrs: {
                      message: _vm.$t("wp.toLittleChar"),
                      type: "error",
                      banner: "",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "d-flex flex-row align-items-center justify-content-center",
            },
            [
              _c("vue-country-code", {
                staticClass: "col-3 country-code",
                attrs: { enabledCountryCode: true, defaultCountry: "tr" },
                on: {
                  onSelect: function ($event) {
                    return _vm.onSelect($event)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-8" },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|numeric|min:6|max:15",
                        expression: "'required|numeric|min:6|max:15'",
                      },
                    ],
                    attrs: {
                      placeholder: _vm.$t("message.phone"),
                      autocomplete: "off",
                      trim: "",
                      type: "text",
                    },
                    model: {
                      value: _vm.whatsappNumber,
                      callback: function ($$v) {
                        _vm.whatsappNumber = $$v
                      },
                      expression: "whatsappNumber",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }